import { LitElement } from 'lit';
import { connect } from '../redux/connect.ts';
import { getStore } from '../redux/store/getStore.ts';

export class ConnectedLitElement extends connect(getStore)(LitElement) {}